import React from "react";
import { useTable } from "../../Components/useTable";

const Pklist = () => {
  const type = "Scheduled PKs";
  const headCells = [
    { id: "name", numeric: false, label: "Name" },
    { id: "location", numeric: false, label: "Location" },
    { id: "opponentOneUser.name", numeric: false, label: "Player 1" },
    { id: "opponentOneUser.picture", numeric: false, label: "Player1 image" },
    { id: "opponentTwoUser.name", numeric: false, label: "Player 2" },
    { id: "opponentTwoUser.picture", numeric: false, label: "Player2 image" },
    { id: "pkDate", numeric: false, label: "Pk Date&Time" },
    { id: "createdAt", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default Pklist;
